
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom'; // Pour récupérer l'ID du domaine depuis l'URL
import { getDomainManagers } from '../../service/api/domainService';
import { getGravatarUrl } from '../../service/api/gravatar';

export default function ListeManagers({ domainId }) {
    const [managers, setManagers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchManagers = async () => {
            setLoading(true);
            setError(null);

            const domainIdNumber = parseInt(domainId, 10);

            if (isNaN(domainIdNumber)) {
                setError("ID de domaine invalide.");
                setLoading(false);
                return;
            }

            try {
                const data = await getDomainManagers(domainIdNumber);
                setManagers(data);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        if (domainId) { // Important : ne charge les données que si domainId est défini
            fetchManagers();
        }

    }, [domainId]); // domainId est maintenant une dépendance

    if (loading) {
        return <div>Chargement des managers...</div>;
    }

    if (error) {
        return <div>Erreur : {error}</div>;
    }

  return (
    <>
        <div className="col-lg-12">
            <div className="card">
                <div className="card-body p-0">
                    <div className="table-responsive">
                    {managers.length === 0 ? (
                        <p className='text-center text-muted'>Aucun manager trouvé pour ce domaine.</p>
                    ) : (
                        <table className="table table-sm mb-0 table-striped order-table" style={{overflowY: 'scroll'}}>
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Name</th>
                                    <th>Email</th>
                                    <th>Phone</th>
                                    <th>Creation Date</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody id="customers">
                                {managers.map(manager => (
                                <tr className="btn-reveal-trigger" key={manager.domainId}>
                                    <td className="py-2">
                                        <div className="media d-flex align-items-center">
                                            <div className=" avatar-xl me-2">
                                                <div className=""><img className="rounded-circle img-fluid"
                                                        src={getGravatarUrl(manager.email)} width="30" alt=""/>
                                                </div>
                                            </div>
                                        </div>      
                                    </td>
                    
                                    <td className="py-2">
                                        <a href="#">
                                            <div className="media d-flex align-items-center">
                                                <div className="media-body">
                                                <h6 className="mb-0 fs--1">
                                                {manager.firstName && manager.lastName
                                                    ? `${manager.firstName} ${manager.lastName}`
                                                    : manager.companyName}
                                                </h6>
                                                </div>
                                            </div>
                                        </a>
                                    </td>
                                    <td className="py-2"><a
                                            href={`mailto:${manager.email}`}>{manager.email}</a></td>
                                    <td className="py-2"> <a href="tel:2012001851">{manager.phoneNumber}</a></td>
                                    
                                    <td className="py-2">{new Date(manager.creationDate).toLocaleDateString()}</td>
                                    <td className="py-2 text-end">
                                        <div className="dropdown"><button className="btn btn-primary tp-btn-light sharp" type="button" data-bs-toggle="dropdown"><span className="fs--1"><svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="18px" height="18px" viewBox="0 0 24 24" version="1.1"><g stroke="none" strokeWidth="1" fill="none" fileRule="evenodd"><rect x="0" y="0" width="24" height="24"></rect><circle fill="#000000" cx="5" cy="12" r="2"></circle><circle fill="#000000" cx="12" cy="12" r="2"></circle><circle fill="#000000" cx="19" cy="12" r="2"></circle></g></svg></span></button>
                                            <div className="dropdown-menu dropdown-menu-end border py-0">
                                                <div className="py-2">
                                                    <a className="dropdown-item text-danger d-flex align-items-center" href="#!" data-bs-toggle="modal" data-bs-target="#deleteManager">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-trash3 me-2" viewBox="0 0 16 16">
                                                            <path d="M6.5 1a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1V2h4.5a.5.5 0 0 1 0 1H1a.5.5 0 0 1 0-1H5.5V1zM4 3h8l-.5 11H4.5L4 3z"/>
                                                        </svg>
                                                        Delete
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                 ))}
                            </tbody>
                        </table>
                        )}
                    </div>
                </div>
            </div>
        </div>
    </>
  )
}


